import React from 'react';

import style from './footer.module.scss';

import { Follow } from './follow';
import { Company } from './company';
import { Copyright } from './copyright';

export const Footer = () => {
    return (
        <div className={style.footer}>
            <div className={style.footerContent}>
                <Follow></Follow>
                <hr className={style.splitLine}></hr>
                <Company></Company>
            </div>
            <Copyright></Copyright>
        </div>
    );
};
